import React, {useState} from 'react';
import {Button, MenuItem} from '@mui/material';
import {useSnackbar} from 'notistack';
import {useTranslation} from 'react-i18next';
import AlertComponent from '@components/modal/Alert.component';
import {finalize, Observable} from 'rxjs';

interface OptionWithAlertComponentProps {
  alertDescription?: string;
  alertTitle: string;
  handleSuccess: () => void;
  handleValidate?: () => Observable<any>;
  label: string;
  validateTitle: string;
}

const OptionWithAlertComponent = (props: OptionWithAlertComponentProps) => {
  const {alertDescription, alertTitle, handleSuccess, handleValidate, label, validateTitle} = props;

  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();

  const [loading, setLoading] = useState(false);

  const [showAlert, setShowAlert] = useState(false);

  return (
    <>
      <MenuItem
        onClick={() => setShowAlert(true)}>
        {label}
      </MenuItem>
      {showAlert && (
        <AlertComponent
          title={alertTitle}
          description={alertDescription}
          handleClose={() => setShowAlert(false)}
          actions={(
            <>
              <Button variant="outlined" color="primary" disabled={loading} onClick={() => setShowAlert(false)}>
                {t('global.cancel')}
              </Button>
              <Button
                variant="contained"
                disabled={loading}
                color="primary"
                onClick={() => {
                  setLoading(true);
                  handleValidate?.().pipe(finalize(() => setLoading(false))).subscribe({
                    next: () => {
                      handleSuccess();
                      setShowAlert(false);
                    },
                    error: (err) => enqueueSnackbar(err.text, err.options),
                  });
                }}>
                {validateTitle}
              </Button>
            </>
          )}/>
      )}
    </>
  );
};

export default OptionWithAlertComponent;